// extracted by mini-css-extract-plugin
module.exports = {"addButton":"FileUpload_addButton__2RCdm","input":"FileUpload_input__2SC5Y"};